import { render } from "./addGoods.vue?vue&type=template&id=76cae9a2&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"

import "./addGoods.vue?vue&type=style&index=0&id=76cae9a2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cae9a2"]])

export default __exports__